var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ant-design:percentage-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7129 4.11719L15.8848 3.28906C15.8554 3.25998 15.8157 3.24367 15.7744 3.24367C15.7331 3.24367 15.6934 3.25998 15.6641 3.28906L3.28711 15.6621C3.25803 15.6915 3.24172 15.7311 3.24172 15.7725C3.24172 15.8138 3.25803 15.8534 3.28711 15.8828L4.11523 16.7109C4.17578 16.7715 4.27539 16.7715 4.33594 16.7109L16.7109 4.33594C16.7734 4.27734 16.7734 4.17773 16.7129 4.11719ZM5.9375 8.75C7.48828 8.75 8.75 7.48828 8.75 5.9375C8.75 4.38672 7.48828 3.125 5.9375 3.125C4.38672 3.125 3.125 4.38672 3.125 5.9375C3.125 7.48828 4.38672 8.75 5.9375 8.75ZM5.9375 4.53125C6.71289 4.53125 7.34375 5.16211 7.34375 5.9375C7.34375 6.71289 6.71289 7.34375 5.9375 7.34375C5.16211 7.34375 4.53125 6.71289 4.53125 5.9375C4.53125 5.16211 5.16211 4.53125 5.9375 4.53125ZM14.0625 11.25C12.5117 11.25 11.25 12.5117 11.25 14.0625C11.25 15.6133 12.5117 16.875 14.0625 16.875C15.6133 16.875 16.875 15.6133 16.875 14.0625C16.875 12.5117 15.6133 11.25 14.0625 11.25ZM14.0625 15.4688C13.2871 15.4688 12.6562 14.8379 12.6562 14.0625C12.6562 13.2871 13.2871 12.6562 14.0625 12.6562C14.8379 12.6562 15.4688 13.2871 15.4688 14.0625C15.4688 14.8379 14.8379 15.4688 14.0625 15.4688Z",
    fill: "#5B5B5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatio);
export default __webpack_public_path__ + "static/media/ratio.1e23b2bdfa6d615f6cf6b0d6cbdd479f.svg";
export { ForwardRef as ReactComponent };